import { render, staticRenderFns } from "./OrderInfoModal.vue?vue&type=template&id=ae6ff04c&scoped=true"
import script from "./OrderInfoModal.vue?vue&type=script&lang=js"
export * from "./OrderInfoModal.vue?vue&type=script&lang=js"
import style0 from "./OrderInfoModal.vue?vue&type=style&index=0&id=ae6ff04c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6ff04c",
  null
  
)

export default component.exports